import { AppDispatch, RootState } from '@src/store/store'
import { authApi } from '@src/api/auth-api'
import {
  logoutAC,
  setBackError,
  setChangePasswordSuccess,
  setIsAuth,
  setIsLoading,
  setIsRecallPasswordNoUser,
  setIsSuccessRecallPassword,
  setIsSuccessRecoveryPassword,
  setNewUserData,
  setRegisterSuccess,
} from '@src/store/ducks/auth/reducer'
import { setIsInitialized } from '@src/store/ducks/app/reducer'
import { keysToCamelCase } from '@src/lib/utils'
import { Store } from 'react-notifications-component'
import { setUser } from '@src/store/ducks/user/reducer'
import { selectUserCurrentAddresses } from '@src/store/ducks/user/selectors'

export const login = (phone: string, password: string) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  dispatch(setBackError(null))
  try {
    const result = await authApi.login(phone.replace(/\D+/g, ''), password)
    dispatch(setIsAuth(true))
    dispatch(setUser(result.userInfo))
  } catch (err: any) {
    console.log(err)
    if (err?.response?.status === 400) {
      dispatch(setBackError(keysToCamelCase(err.response.data)))
    }
    dispatch(setIsLoading(false))
  }
}
export const registration = (phone: string, uid: any, systemName: any) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  dispatch(setBackError(null))
  try {
    dispatch(setIsLoading(true))
    await authApi.register(phone.replace(/\D+/g, ''), uid, systemName)
    dispatch(setRegisterSuccess())
    Store.addNotification({
      message: 'Пользователь успешно зарегистрирован',
      type: 'success',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status === 400) {
      dispatch(setBackError(keysToCamelCase(err.response.data)))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const logout = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  const { isAuth } = getState()
  try {
    dispatch(logoutAC())
    dispatch(setIsInitialized())
    if (isAuth.isAuth) {
      await authApi.logout()
    }
  } catch (err) {
    console.error(err)
  }
}

export const sendNewPassword = (
  data: { oldPassword: string, password: string },
) => async (dispatch: AppDispatch, getState: () => RootState) => {
  dispatch(setIsLoading(true))
  try {
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      await authApi.changePassword({ ...data, account: currentAddresses.account })
      dispatch(setChangePasswordSuccess(true))
    }
  } catch (err: any) {
    console.error(err)
    if (err?.response?.status === 400) {
      dispatch(setBackError(keysToCamelCase(err.response.data)))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const recallPassword = (account: string, phone: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setBackError(null))
    dispatch(setIsLoading(true))
    await authApi.recallPassword(account, phone.replace(/\D+/g, ''))
    dispatch(setIsSuccessRecallPassword(true))
    // @ts-ignore
    if (window?.ReactNativeWebView?.postMessage) {
      setTimeout(() => {
        // @ts-ignore
        window.ReactNativeWebView.postMessage('close')
      }, 2000)
    }
  } catch (err: any) {
    console.error(err)
    if (err.response.status === 404) {
      dispatch(setIsRecallPasswordNoUser(true))
      dispatch(setBackError(err.response.data))
    } else {
      dispatch(setBackError(err.response.data))
    }
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const recallPasswordByPassport = (account: string, passport: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setBackError(null))
    dispatch(setIsLoading(true))
    const result = await authApi.recallPasswordByPassport(account, passport)
    dispatch(setIsSuccessRecoveryPassword(true))
    dispatch(setIsSuccessRecallPassword(true))
    dispatch(setNewUserData(result))
  } catch (err: any) {
    console.error(err)
    dispatch(setBackError(err.response.data))
  } finally {
    dispatch(setIsLoading(false))
  }
}
